import { render, staticRenderFns } from "./TransferReport.vue?vue&type=template&id=c6e8df9c&scoped=true&"
import script from "./TransferReport.vue?vue&type=script&lang=js&"
export * from "./TransferReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e8df9c",
  null
  
)

export default component.exports